import React from "react";
import "./CloverStationSoloPricingTable.css"; 
import { FormattedMessage} from "react-intl";
import SideFlag from "../../../images/additional_img/side_flag.svg"; 

export default function Index() {
    return (
        <div className="clover_station_duo_pricing_container">
            <div className="clover_station_duo_base">
                <div className="clover_station_duo_w_layout_grid clover_station_duo_pricing_grid">
                    <div className="price-card-base">
                        <div className="pricing-card-featured">
                            <h1 className="pricing">
                                $55
                                <span className="length-text"><FormattedMessage id={"month"}/></span>
                            </h1>
                            <h3 className="price-type"><FormattedMessage id={"lease_to_own"}/></h3>
                            <p className="pricing-text"><FormattedMessage id={"most_popular_option"}/></p>
                            <div className="clover_station_duo_w_layout_grid pricing-features">
                                <div className="check-wrap">
                                    <img src={SideFlag} className="check"/>
                                    <div className="feature-text"><FormattedMessage id={"four_years_term"}/></div>
                                </div>
                                <div className="check-wrap">
                                    <img src={SideFlag} className="check"/>
                                    <div className="feature-text"><FormattedMessage id={"payment_end"}/></div>
                                </div>
                                <div className="check-wrap">
                                    <img src={SideFlag} className="check"/>
                                    <div className="feature-text"><FormattedMessage id={"cash_flow_friendly"}/></div>
                                </div>
                            </div>
                            <a href="/clover-application" className="button-4 button-white w-button"><FormattedMessage id={"get_started"}/></a>
                        </div>
                    </div>
                    <div className="price-card">
                        <h1 className="pricing">
                            $1495
                            <span class="length-text"><FormattedMessage id={"one_time"}/></span>
                        </h1>
                        <h3 className="price-type"><FormattedMessage id={"purchase"}/></h3>
                        <div class="clover_station_duo_w_layout_grid pricing-features">
                            <div className="check-wrap">
                                <img src={SideFlag} className="check"/>
                                <div className="feature-text"><FormattedMessage id={"cheapest_cost"}/></div>
                            </div>
                            <div className="check-wrap">
                                <img src={SideFlag} className="check"/>
                                <div className="feature-text"><FormattedMessage id={"one_year_manufacturer"}/></div>
                            </div>
                            <div className="check-wrap">
                                <img src={SideFlag} className="check"/>
                                <div className="feature-text"><FormattedMessage id={"no_monthly_fees"}/></div>
                            </div>
                        </div>
                        <a href="/clover-application" className="button-4 w-button"><FormattedMessage id={"get_started"}/></a>
                    </div>
                </div>
            </div>
        </div>
    )
}